import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataAssistants: localStorage.getItem("dataAssistants")
    ? JSON.parse(localStorage.getItem("dataAssistants"))
    : null,
  newAssistant: null,
  activeAssistant: localStorage.getItem("activeAssistant")
    ? JSON.parse(localStorage.getItem("activeAssistant"))
    : null,
  updateAssistant: null,
  filesList: [],

  rebuildInstructionDialogId: null,

  isLoadingAssistant: true,
  // settingsAssistant: null
};

const assistantSlice = createSlice({
  name: "assistant",
  initialState,
  reducers: {
    setDataAssistants(state, action) {
      state.dataAssistants = action.payload;
      state.isLoadingAssistant = false;
    },
    setNewAssistant: (state, action) => {
      state.newAssistant = {
        ...state.newAssistant,
        ...action.payload,
      };
    },
    setUpdateAssistant(state, action) {
      state.updateAssistant = action.payload;
    },
    setActiveAssistant(state, action) {
      state.activeAssistant = action.payload;
    },
    setGlobalFilesList(state, action) {
      state.filesList = [...state.filesList, action.payload];
    },

    setRebuildInstructionDialogId(state, action) {
      state.rebuildInstructionDialogId = action.payload;
    },
    setIsLoadingAssistant(state, action) {
      state.isLoadingAssistant = action.payload;
    },
  },
});

export const {
  setDataAssistants,
  setNewAssistant,
  setActiveAssistant,
  setUpdateAssistant,
  setGlobalFilesList,
  setRebuildInstructionDialogId,
  setIsLoadingAssistant,
} = assistantSlice.actions;

export default assistantSlice.reducer;
